import { render, staticRenderFns } from "./LoadingIndicatorComponent.vue?vue&type=template&id=0c020462"
import script from "./LoadingIndicatorComponent.vue?vue&type=script&lang=js"
export * from "./LoadingIndicatorComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports